export default {"src":"/_next/static/media/VTI.c3ae9c1c.svg","height":18,"width":18};